import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import SEO from "../../components/SEO";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { color, motion, transform } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import industryIntegration from "../../images/v4/salesManagers/sales.png";
import DesignCrmCarousel from "../../components/v4/designCarousel/DesignCarousel";
import salesmanpageHerobg from "../../images/v4/salesManagers/salesMangerHero.png";
import salesCrmCarouselbg from "../../images/v4/salesManagers/salesCrmbg.png";
import realWorldbg from "../../images/v4/salesManagers/realWorldbg.png";

import salesImg1 from "../../images/v4/salesManagers/salesslider/img1.svg";
import salesImg2 from "../../images/v4/salesManagers/salesslider/img2.svg";
import salesImg3 from "../../images/v4/salesManagers/salesslider/img3.svg";
import salesImg4 from "../../images/v4/salesManagers/salesslider/img4.svg";
import salesImg5 from "../../images/v4/salesManagers/salesslider/img5.svg";
import salesImg6 from "../../images/v4/salesManagers/salesslider/img6.svg";

import adaptImg1 from "../../images/v4/salesManagers/clientSlider/img1.png";
import adaptImg2 from "../../images/v4/salesManagers/clientSlider/img2.png";
import adaptImg3 from "../../images/v4/salesManagers/clientSlider/img3.png";
import adaptImg4 from "../../images/v4/salesManagers/clientSlider/img4.png";
import adaptImg5 from "../../images/v4/salesManagers/clientSlider/img5.png";
import adaptImg6 from "../../images/v4/salesManagers/clientSlider/img6.png";
import adaptImg7 from "../../images/v4/salesManagers/clientSlider/img7.png";

import bannerIcon1 from "../../images/v4/salesManagers/bannerIcons/icon1.svg";
import bannerIcon2 from "../../images/v4/salesManagers/bannerIcons/icon2.svg";
import bannerIcon3 from "../../images/v4/salesManagers/bannerIcons/icon3.svg";
import bannerIcon4 from "../../images/v4/salesManagers/bannerIcons/icon4.svg";

import bussinessSuccessbg from "../../images/v4/salesManagers/bussinessSuccess.png";

import leadCaptureIcon from "../../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../../images/v4/industryPage/videoConference.png";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import bannerTick from "../../images/v4/salesReps/heroTick.svg";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/salesReps/topcrm/zoho.png";
import compareItemImg3 from "../../images/v4/salesManagers/topcrm/pipedrive.png";
import compareItemImg4 from "../../images/v4/salesReps/topcrm/freshsale.png";
import compareItemImg5 from "../../images/v4/salesReps/topcrm/monday.png";

import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";

import realWorldImage2 from "../../images/v4/salesManagers/realWorld/real1.png";
import realWorldImage3 from "../../images/v4/salesManagers/realWorld/real2.png";
import realWorldImage4 from "../../images/v4/salesManagers/realWorld/real3.png";
import realWorldImage5 from "../../images/v4/salesManagers/realWorld/real4.png";
import realWorldImage6 from "../../images/v4/salesManagers/realWorld/real5.png";

import broadcastImg1 from "../../images/v4/salesReps/Designfor/broadcast1.png";
import broadcastImg2 from "../../images/v4/salesReps/Designfor/broadcast2.png";
import broadcastImg3 from "../../images/v4/salesReps/Designfor/broadcast3.png";
import broadcastImg4 from "../../images/v4/salesReps/Designfor/broadcast4.png";
import broadcastImg5 from "../../images/v4/salesReps/Designfor/broadcast5.png";

import experienceImg2 from "../../images/v4/salesManagers/experience/exp2.png";
import experienceImg3 from "../../images/v4/salesManagers/experience/exp3.png";
import experienceImg4 from "../../images/v4/salesManagers/experience/exp4.png";
import experienceImg5 from "../../images/v4/salesManagers/experience/exp5.png";
import experienceImg6 from "../../images/v4/salesManagers/experience/exp6.png";

import arrowRight from "../../images/v4/salesReps/arrowRight.svg";

const useStyles = makeStyles((theme) => ({
  SalesMangerSection: {
    backgroundSize: "cover",
    backgroundImage: `url(${salesmanpageHerobg})`,
    padding: "60px 0 0",
    backgroundPosition: "top",
    overflow: "hidden",
    "@media only screen and (max-width: 1024px)": {
      maxHeight: "100%",
      minHeight: "100%",
      "& .container": {
        height: "auto",
      },
      "& .centerContainer": {
        width: "90%",
        marginTop: "50px",
      },
    },

    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      marginTop: "70px",
    },

    "@media only screen and (max-width: 768px)": {
      padding: "0",
      "& .centerContainer": {
        width: "95%",
        marginTop: "40px",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
        marginTop: "30px",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& .centerContainer": {
        marginTop: "20px",
        gap: "16px",
      },
    },
  },
  SalesMangerContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
  },
  heroContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: "32px",
    textAlign: "center",
    margin: "0 auto 64px",
    maxWidth: "1200px",
    "& p": {
      maxWidth: "1000px",
      marginBottom: "8px",
    },
    "@media(max-width:1024px)": {
      "& h1": {
        margin: "0",
      },
    },
  },
  bannerCards: {
    display: "flex",
    alignItems: "flex-start",
    gap: "24px",
    flexWrap: "nowrap", // default unless overridden below
    "& .bannerCard:nth-of-type(1), & .bannerCard:nth-of-type(4)": {
      transform: "translateY(25px) !important",
    },
    "@media (max-width:1024px)": {
      flexWrap: "wrap",
      alignItems: "stretch",
      "& .bannerCard:nth-of-type(1), & .bannerCard:nth-of-type(4)": {
        transform: "translateY(0) !important",
      },
    },
    "@media(max-width:768px)": {
      gap: "15px",
    },
  },
  salesSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "50%",
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& .bannerDescription": {
      margin: "24px 0",
      "@media only screen and (max-width: 768px)": {
        margin: "24px 0",
      },
      "@media only screen and (max-width: 600px)": {
        margin: "20px 0",
      },
    },
  },
  aiSectionRight: {
    width: "50%",
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
      paddingTop: "20%",
      "& img": {
        transform: "translateY(1%)!important",
      },
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      paddingTop: "0",
      maxWidth: "500px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      maxWidth: "400px",
    },
    "@media only screen and (max-width: 480px)": {
      maxWidth: "350px",
    },
    "& img": {
      transform: "translateY(25%)",
    },
  },
  integrationContent: {
    width: "100%",
    textAlign: "center",
    color: "#fff",
    "& h2": {
      marginBottom: "16px !important",
      marginTop: "0 !important",
    },
    "& p": {
      marginBottom: "16px",
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& p": {
        paddingRight: "40px",
        fontSize: "18px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& p": {
        paddingRight: "0",
        textAlign: "center",
        fontSize: "16px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginBottom: "20px",
      "& p": {
        fontSize: "14px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& p": {
        fontSize: "13px",
      },
    },
  },

  bussinessSuccesSection: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${bussinessSuccessbg})`,
    paddingTop: "100px",
    position: "relative",
    "& .logos-container": {
      background: "transparent",
      "&::before,&::after": {
        display: "none",
      },
      "& .logo": {
        backgroundColor: "#208EEC26",
        color: "#B6DDFF",
        "& img": {
          width: "48px",
          height: "48px",
        },
      },
      "@media only screen and (max-width: 768px)": {
        paddingBottom: "20px!important",
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "80px",
      backgroundPositionX: "center",
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "60px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "60px 0",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "40px 0",
    },
  },
  bussinessSuccessContainer: {
    display: "flex",
    alignItems: "center",
    maxWidth: "1200px",
    margin: "0 auto",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
    },
  },
  integrationHeaderItem: {
    width: "100%",
    marginBottom: "90px",
    "& h2": {
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& h2": {
        paddingRight: "40px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
      "& h2": {
        textAlign: "center",
        paddingRight: "0",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& h2": {
        textAlign: "center",
      },
    },
  },
  statsContainer: {
    display: "flex",
    alignItems: "stretch",
    flexWrap: "wrap",
    gap: "18px",
    justifyContent: "flex-start",
    width: "100%",
    marginTop: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
      marginTop: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
      marginTop: "25px",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "15px",
      marginTop: "20px",
      position: "relative",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "12px",
      marginTop: "15px",
    },
  },
  customerExperencesBox: {
    width: "32%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "50px",
    background: "#002c51",
    borderRadius: "15px",
    padding: "20px",
    minHeight: "230px",
    backdropFilter: "blur(30px) brightness(0.8)",
    overflow: "hidden",

    "& p:nth-child(2)": {
      color: "#D1E4F1",
    },
    "& p:last-child": {
      color: "#D1E4F1",
    },
    "@media only screen and (max-width: 1024px)": {
      width: "31%",
      gap: "30px",
      padding: "18px",
      minHeight: "200px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "48%",
      gap: "25px",
      padding: "16px",
      minHeight: "180px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      padding: "15px",
      borderRadius: "20px",
      minHeight: "max-content",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "12px",
      gap: "12px",
    },
    "&.orangeCard1": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard3": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard5": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard7": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.blueCard3": {
      background: "rgba(0, 154, 153, 0.4)",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #1ADAD9 50%, #00aa7c 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard0": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard2": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard4": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard6": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.greenCard7": {
      background: "#002C51",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #208EEC 50%, #002C51 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    overflow: "auto",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "5px",
    },
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tab: {
    width: "33%",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px",
    },
  },
  tabCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: "32px",
    gap: "40px",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
    },
  },
  tabCardLeftContainer: {
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    alignItems: "flex-start",
    "@media only screen and (max-width: 768px)": {
      alignItems: "center",
      width: "100%",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    width: "24px!important",
    "& img": {
      width: "100%",
      marginTop: "6px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "24px!important",
    },
  },

  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 1024px)": {
      "& .centerContainer": {
        width: "90%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& .centerContainer": {
        width: "95%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& .centerContainer": {
        gap: "16px",
      },
    },
  },
  wpFaq: {
    "& section": {
      padding: "0px 0 40px !important",
    },

    "@media only screen and (max-width: 1024px)": {
      "& section": {
        padding: "0px 0 35px !important",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& section": {
        padding: "0px 0 30px !important",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 40px !important",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& section": {
        padding: "0px 0 25px !important",
      },
    },
  },
  integrationSection: {},
  integrationHeader: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: "70px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& div": {
      width: "50%",
      "@media only screen and (max-width: 768px)": {
        width: "100%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .buttonContaienr": {
      marginTop: "42px",
      "@media only screen and (max-width: 1024px)": {
        marginTop: "35px",
      },
      "@media only screen and (max-width: 768px)": {
        marginTop: "30px",
      },
      "@media only screen and (max-width: 600px)": {
        marginTop: "20px",
      },
      "@media only screen and (max-width: 480px)": {
        marginTop: "15px",
      },
      "& a": {
        color: "#FF682A",

        "&:hover": {
          color: "#fff",
        },
      },
    },
  },
  integrationRightImage: {
    width: "100%",
  },
  combineSection: {
    position: "relative",
    "@media only screen and (max-width: 768px)": {
      marginTop: "40px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "30px",
    },
    "@media only screen and (max-width: 480px)": {
      marginTop: "20px",
    },
  },
  adaptSlider: {
    padding: "15px 0!important",
    "@media only screen and (max-width: 1024px)": {
      padding: "15px 4rem 50px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "15px 2rem 40px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "15px 10px 30px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
    "@media only screen and (max-width: 768px)": {
      position: "static",
      transform: "translate(0, 0)",
    },
  },
  bannerPoint: {
    display: "flex",
    flexDirection: "column",
    gap: "22px",
    marginBottom: "20px",
    "@media only screen and (max-width: 1024px)": {
      gap: "20px",
      marginBottom: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "18px",
      marginBottom: "16px",
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      gap: "16px",
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "14px",
      marginBottom: "12px",
    },
  },
  banerPointItem: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    "&:last-child": {
      marginBottom: "42px",
    },
    "& img": {
      width: "32px",
      height: "32px",
    },
    "&:last-child": {
      marginBottom: "40px",
    },
    "@media only screen and (max-width: 1024px)": {
      gap: "14px",
      "& img": {
        width: "30px",
        height: "30px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
      "& img": {
        width: "28px",
        height: "28px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      gap: "10px",
      "& img": {
        width: "26px",
        height: "26px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
      "& img": {
        width: "24px",
        height: "24px",
      },
    },
  },
  salesCrmCarousel: {
    backgroundImage: `url(${salesCrmCarouselbg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingBottom: "65px",
    "& .header-section": {
      flexDirection: "column",
      width: "55%",
      "& h2": {
        marginBottom: "32px",
      },
      "& p": {
        marginBottom: "0",
      },
      "@media(max-width:768px)": {
        width: "100%",
        "& h2": {
          marginBottom: "20px",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingBottom: "60px",
      "& .header": {
        width: "60%",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingBottom: "50px",
      "& .header": {
        width: "80%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px",
      "& .header": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 480px)": {
      paddingBottom: "30px",
    },
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "180px",
      paddingBottom: "70px",
      "& .header": {
        width: "80%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "150px",
      paddingBottom: "60px",
      "& .header": {
        width: "90%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "600px",
      paddingBottom: "40px",
      "& .container:first-child": {
        padding: "0px 15px",
      },
      "& .header": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      paddingTop: "500px",
      paddingBottom: "30px",
      "& .header": {
        gap: "16px",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "12px 16px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "10px 14px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "8px 12px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "6px 10px",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 1024px)": {
      width: "35%",
      top: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 1024px)": {
      width: "65%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "@media only screen and (max-width: 1024px)": {
      marginBottom: "50px",
      gap: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "40px",
      gap: "16px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "30px",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      marginBottom: "25px",
      gap: "12px",
    },
  },
  experienceContainer: {
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      "@media only screen and (max-width: 1024px)": {
        width: "80%",
      },
      "@media only screen and (max-width: 768px)": {
        width: "90%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
  },
  experienceInnerContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "20px",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
      marginTop: "0",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
      alignItems: "flex-start",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
    },
  },
  experienceContainerLeft: {
    width: "40%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
    "& .exp-desc": {
      marginBottom: "24px",
    },
    "& .view-more-link": {
      textDecoration: "underline",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      color: "#1D6FB6",
      marginBottom: "20px",
      "& img": {
        display: "inline-block!important",
        width: "16px!important",
        height: "16px",
        marginTop: "3px!important",
        transition: "transform 0.5s ease",
      },
      "&:hover": {
        color: "#010F1D",
        "& img": {
          transform: "translateX(5px)",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
      gap: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      gap: "24px",
      alignItems: "center",
      textAlign: "center",
      "& .exp-desc": {
        marginBottom: "16px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginTop: "0px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "18px",
    },
  },
  experienceContainerRight: {
    width: "60%",
    minHeight: "450px",
    "& img": {
      width: "100%",
      height: "100%",
    },
    "@media only screen and (max-width: 768px)": {
      display: "none",
    },
  },
  faqHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
      gap: "10px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  collapseBody: {
    margin: "0",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0  ",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },

  accordianTabs: {
    paddingBottom: "300px",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      paddingBottom: "250px",
    },
    "@media only screen and (max-width: 768px)": {
      paddingBottom: "0",
    },

    "& .headercenterContainer": {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      marginBottom: "64px",
      gap: "100px",
      "& h2": {
        width: "50%",
      },
      "& p": {
        width: "40%",
      },
      "@media (max-width:768px)": {
        flexDirection: "column",
        gap: "20px",
        marginBottom: "55px",
        "& h2": {
          width: "100%",
        },
        "& p": {
          width: "100%",
        },
      },
    },
  },
  realWorldTabs: {
    backgroundImage: `url(${realWorldbg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingTop: "300px",
    "& .container": {
      padding: "0 0 120px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "250px",
      "& .container": {
        padding: "0 24px 65px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      padding: "65px 15px",
      "& .container": {
        padding: "0 15px ",
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "40px 15px",
      "& .container": {
        padding: "0",
      },
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
      "& h2": {
        width: "80%",
      },
    },
    "@media only screen and (max-width: 1200px)": {
      "& .centerContainer": {
        "& h2": {
          width: "100%",
        },
      },
    },
  },

  adaptsBox: {
    gap: "24px",
    display: "flex!important",
    padding: "24px",
    background: "#fff",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "flex-start",
    boxShadow: "0px 0px 24px #D4E0E9",
    borderRadius: "16px",
    height: "auto!important",
    "@media only screen and (max-width: 1024px)": {
      padding: "20px",
      maxWidth: "350px",
      gap: "14px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "18px",
      maxWidth: "320px",
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "12px",
      maxWidth: "85%",
      gap: "10px",
    },
  },
  adaptDescription: {
    gap: "10px",
    minHeight: "80px",
    "@media only screen and (max-width: 1024px)": {
      minHeight: "70px",
    },
    "@media only screen and (max-width: 768px)": {
      minHeight: "60px",
    },
    "@media only screen and (max-width: 600px)": {
      alignItems: "baseline",
      minHeight: "auto",
    },
    "@media only screen and (max-width: 480px)": {
      minHeight: "auto",
    },
  },
  adaptBoxImg: {
    width: "48px",
    maxWidth: "48px",
    position: "relative",
    bottom: "0",
    marginBottom: "24px",
    "@media only screen and (max-width: 1024px)": {
      width: "44px",
      maxWidth: "44px",
      marginBottom: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "40px",
      maxWidth: "40px",
      marginBottom: "18px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "36px",
      maxWidth: "36px",
      marginBottom: "16px",
    },
    "@media only screen and (max-width: 480px)": {
      width: "32px",
      maxWidth: "32px",
      marginBottom: "14px",
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "15px",
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "12px",
    },
  },
  integrationLeft: {
    "@media only screen and (max-width: 768px)": {
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      textAlign: "left",
    },
  },
  integrationRight: {
    "@media only screen and (max-width: 768px)": {
      maxWidth: "500px",
      margin: "0 auto",
    },
    "@media only screen and (max-width: 600px)": {
      maxWidth: "400px",
    },
    "@media only screen and (max-width: 480px)": {
      maxWidth: "350px",
    },
  },

  tabCardRightContainer: {
    width: "50%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  broadcastBox: {
    padding: "32px 32px 0",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "0 auto",

    "& img": {
      maxWidth: "80%",
      width: "auto",
      height: "auto",
      margin: "24px auto 0",
      display: "table",
      "@media(max-width: 768px)": {
        width: "auto",
        maxWidth: "auto",
      },
      "@media(max-width: 768px)": {
        width: "auto",
        maxWidth: "90%",
        height: "auto",
      },
    },
  },
  designCrmCarousel: {
    backgroundColor: "#e9f4fd",
    "& .designHeader": {
      maxWidth: "55%",
      "& h2": {
        marginBottom: "24px",
      },
      "& p": {
        marginBottom: "16px",
        fontSize: "20px",
      },
      "@media(max-width:768px)": {
        maxWidth: "100%",
      },
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
      "& .swiper-slide": {
        height: "auto!important",
      },
    },
    "@media(max-width:768px)": {
      "& .swiper-wrapper": {
        padding: "0 24px ",
      },
    },
    ".swiper-slide": {
      width: "100%!important",
    },
  },
  broadcastContainerInner: {
    display: "flex",
    flexDirection: "column-reverse",
    paddingBottom: "86px",
    "@media(max-width:1024px)": {
      padding: "0 50px 32px!important",
    },
    "@media(max-width:600px)": {
      padding: "0 0 32px!important",
    },
    "& .swiper-button-prev": {
      top: "100px !important",
      left: "auto",
      right: "200px",
      color: "#010f1d",
      width: "78px",
      height: "78px",
      borderRadius: "50%",
      border: "2px solid #53677c",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:after": {
        fontSize: "24px",
      },
    },
    "& .swiper-button-next": {
      top: "100px !important",
      right: "100px",
      color: "#010f1d",
      width: "78px",
      height: "78px",
      borderRadius: "50%",
      border: "2px solid #53677c",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:after": {
        fontSize: "24px",
      },
    },
  },
  faqBoxAccordian: {
    padding: "0 16px",
    backgroundColor: "#fff",
    borderRadius: "16px",
    position: "relative",
    transition: "all 0.3s ease",
    cursor: "pointer",
    "& h3": {
      color: "#0A2035",
      opacity: "0.7",
    },
    "&:after": {
      content: '""',
      position: "absolute",
      left: "0",
      top: "0",
      width: "2px",
      height: "100%",
      background: "rgba(0, 0, 0, 0.2)",
    },
    "&:before": {
      content: '""',
      position: "absolute",
      background: "#B1DBFF",
      background:
        "linear-gradient(180deg,rgba(177, 219, 255, 1) 16%, rgba(0, 137, 255, 1) 75%, rgba(0, 137, 255, 1) 80%)",
      left: "-1px",
      top: "0",
      width: "4px",
      height: "100%",
      transform: "scaleY(0)",
      transformOrigin: "top",
      zIndex: 1,
    },
    "&.active": {
      "& h3": {
        color: "#0A2035",
        opacity: "1",
      },
      "&:before": {
        animation: "growTimer 10s linear forwards", // Same as JS interval
      },
    },
    "& .body": {
      margin: "0",
    },
    "& .exp-desc": {
      margin: "10px 0 16px",
    },
  },
  experienceHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
  },
  topFiveHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  testimonials: {
    background: "#FCF8FF",
    paddingBottom: "50px",
    "@media(max-width:1025px)": {
      paddingBottom: "24px",
    },
  },
  smallCardContainer: {
    marginTop: "30px",
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    "& $cardContainer": {
      width: "32%",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      marginTop: "16px",
      gap: "15px",
      "& $cardContainer": {
        height: "400px",
        width: "100%",
        padding: "16px",
      },
    },
  },
  cardContainer: {
    borderRadius: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "18px",
    padding: "25px",
    background: "rgba(0, 44, 81, 0.4)",
    backdropFilter: "blur(20px)",
    height: "320px",
    position: "relative",
    overflow: "hidden",
    "&.greenCard": {
      background: "#014957",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #028BA6 60%, #014957 100%)",
          borderRadius: "50%",
          filter: "blur(80px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.purpleCard": {
      background: "#41086E",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "400px",
          height: "400px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 30%, #B458FF 50%)",
          borderRadius: "50%",
          filter: "blur(200px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.blueCard": {
      background: "#026f85",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background:
            "radial-gradient(circle,rgb(5, 182, 217) 80%, #026f85 100%)",
          borderRadius: "50%",
          filter: "blur(80px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard": {
      background: "rgb(0, 45, 81)",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #3ac4ff 30%, #1f79d3 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "@media(max-width:1024px)": {
      "&.bannerCard": {
        width: "48%",
        minWidth: "48%",
        height: "auto",
      },
    },
    "@media(max-width:992px)": {
      "&.bannerCard": {
        width: "48%",
        minWidth: "48%",
        height: "auto",
        "& h3": {
          margin: "0",
        },
      },
    },
    "@media(max-width:600px)": {
      padding: "16px",
      gap: "8px",
      "&.bannerCard": {
        width: "48%",
        minWidth: "46%",
        height: "auto",
        "& h3": {
          margin: "0",
        },
      },
    },
    "@media(max-width:400px)": {
      padding: "16px",
      gap: "8px",
      "&.bannerCard": {
        width: "47%",
        minWidth: "46%",
        height: "auto",
        "& h3": {
          margin: "0",
        },
      },
    },
  },
  Client: {
    position: "relative",
    zIndex: "10",
    "& .container": {
      paddingTop: "0",
      "@media(max-width:1024px)": {
        padding: "65px 25px",
        "& .client-logo": {
          "& img": {
            width: "auto",
            height: "30px",
          },
        },
      },
      "@media(max-width:768px)": {
        "& .client-logo": {
          "& img": {
            width: "auto",
            height: "25px",
          },
        },
      },

      "@media(max-width:600px)": {
        padding: "40px 15px",
        "& .client-logo": {
          "& img": {
            width: "auto",
            height: "20px",
          },
        },
      },
    },
    "& p": {
      textAlign: "center",
      marginBottom: "32px",
    },
    "& .client-logo": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": {
        width: "auto",
        height: "30px",
      },
    },
  },
  broadcastheader: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
  },
  cardHeader: {
    "& p": {
      lineHeight: "1",
    },
  },
}));

const AUTO_PLAY_INTERVAL = 10000;

const experienceList = [
  {
    title: "Organise and monitor sales pipelines",
    alt: "Multi-stage sales pipelines",
    lintText: "More about sales pipeline",
    linkUrl: "https://peppercloud.com/sales-pipeline-management-tool/",
    img: experienceImg2,
    alt: "Pepper Cloud CRM sales pipeline dashboard",
    desc: "Pepper Cloud CRM gives managers complete visibility into every sales pipeline. Monitor the progress of each sales representative, track leads, and identify bottlenecks quickly. Focus on what matters most with the customisable views. Forecast sales with ease.",
  },
  {
    title: "Make smarter decisions with real-time insights",
    alt: "Broadcast to boost sales",
    lintText: "More about dashboards",
    linkUrl: "https://peppercloud.com/sales-dashboard/",
    img: experienceImg3,
    desc: "Turn performance data into action with intuitive dashboards. From lead source tracking to activity breakdowns, get instant clarity on what’s working. Use the insights to coach underperformers and replicate success across the team. Data-led leadership starts here.",
  },
  {
    title: "Streamline sales activities with automation",
    alt: "AI-integrated sales automation",
    lintText: "More about workflow automation",
    linkUrl: "https://peppercloud.com/sales-crm-features/workflow-automation/",
    img: experienceImg4,
    desc: "Assign tasks, track follow-ups, and set reminders—all from a single CRM system. Stay on track anywhere, anytime with streamlined sales activities and sales automation. Save time on manual tracking while maintaining full control. Ensure consistent output without micromanagement.",
  },
  {
    title: "Unify conversations with omnichannel visibility",
    alt: "Multichannel CRM for sales team",
    lintText: "More about multichannel integration",
    linkUrl:
      "https://peppercloud.com/sales-crm-features/multichannel-integration-for-sales-marketing/",
    img: experienceImg5,
    desc: "Keep your team aligned with integrated WhatsApp CRM and email tools. All customer interactions appear in one shared inbox for full transparency. Approve replies, share product catalogues, and manage templates with ease. Lead communication without jumping across platforms.",
  },
  {
    title: "Lead from anywhere with mobile CRM",
    alt: "Mobile CRM",
    lintText: "Try mobile CRM",
    linkUrl: "https://peppercloud.com/best-mobile-crm-system-app-ios-android/",
    img: experienceImg6,
    desc: "Stay connected on the move with Pepper Cloud’s mobile CRM. Access live pipelines and monitor team tasks in real time. Whether travelling or remote, sales managers can take decisive actions anytime. Leadership stays agile, no matter where you are.",
  },
];

const tabContentData = [
  {
    tabContent: [
      {
        heading: "Custom sales pipeline stages",
        content:
          "Tailor pipelines to software sales—track leads from demo to proposal and contract stages.",
        alt: "Custom sales pipeline stages",
      },
      {
        heading: "Assign tasks with automation",
        content:
          "Set follow-up tasks for reps based on activity, ensuring demos and check-ins are never missed.",
        alt: "Assign tasks with automation",
      },
      {
        heading: "AssistAI for effective communication",
        content:
          "Use conversational AI to rephrase messages, craft effective responses, or retrieve information from the knowledge base.",
        alt: "AssistAI for effective communication",
      },
      {
        heading: "Monitor team-wide KPIs",
        content:
          "Compare conversion, follow-up rates, and forecasts by BDM or geography with dashboards.",
        alt: "Monitor team-wide KPIs",
      },
    ],
    image: realWorldImage2,
    alt: " IT and software service companies",
    subtitle:
      "Sales managers in IT firms handle complex, high-value deals with multiple stakeholders. Pepper Cloud CRM streamlines tracking, follow-ups, and reporting.",
  },
  {
    tabContent: [
      {
        heading: "Lead tracking by product line",
        content:
          "Organise and monitor enquiries based on machinery, parts, or bulk materials.",
        alt: "Product-based lead tracking",
      },
      {
        heading: "Send catalogues via WhatsApp",
        content:
          "Share up-to-date catalogues and pricing using interactive templates to accelerate decisions.",
        alt: "WhatsApp catalogue sharing",
      },
      {
        heading: "Assign follow-ups by territory",
        content:
          "Allocate tasks based on rep zones or plant locations for better accountability.",
        alt: "Territory-based task assignment",
      },
      {
        heading: "Sales activity reports",
        content:
          "Track visits, quote submissions, and interactions with performance insights weekly.",
        alt: "Weekly sales reporting",
      },
    ],
    image: realWorldImage3,
    alt: "Manufacturing and B2B suppliers",
    subtitle:
      "Managers must handle long cycles, distributor chains, and volume deals. Pepper Cloud provides control over sales operations.",
  },
  {
    tabContent: [
      {
        heading: "Segment leads by scope",
        content:
          "Categorise leads into residential, commercial, or turnkey projects to route correctly.",
        alt: "Lead segmentation by project type",
      },
      {
        heading: "Visual updates via WhatsApp",
        content:
          "Share mood boards, 3D renders, or progress photos using WhatsApp tools.",
        alt: "Visual sharing on WhatsApp",
      },
      {
        heading: "Team task coordination",
        content:
          "Assign consults, site visits, and approvals to team members with deadlines.",
        alt: "Team task management",
      },
      {
        heading: "Pipeline progress tracking",
        content:
          "View each project’s progress, communication, and conversion timelines in one dashboard.",
        alt: "Project pipeline visibility",
      },
    ],
    image: realWorldImage4,
    alt: "Interior design and construction firms",
    subtitle:
      "Project industries like design demand timelines and communication. Pepper Cloud supports tracking and engagement.",
  },
  {
    tabContent: [
      {
        heading: "Segment leads by product type",
        content:
          "Categorise leads as loans, insurance, or investments and track their journey.",
        alt: "Financial product lead segmentation",
      },
      {
        heading: "Automated renewal alerts",
        content:
          "Ensure timely renewals, document requests, or reviews with reminder workflows.",
        alt: "Policy renewal automation",
      },
      {
        heading: "Secure WhatsApp integration",
        content:
          "Engage clients with policy updates, confirmations, and reminders using templates.",
        alt: "WhatsApp client communication",
      },
      {
        heading: "Track advisor productivity",
        content:
          "Get a daily view of meetings, calls, tasks scheduled, and targets achieved.",
        alt: "Advisor performance tracking",
      },
    ],
    image: realWorldImage5,
    alt: "Financial services and insurance",
    subtitle:
      "In regulated industries, managers need CRM tools and proactive communication. Pepper Cloud supports clarity and control.",
  },
  {
    tabContent: [
      {
        heading: "Capture leads from forms",
        content:
          "Collect enquiries from websites or campaigns and assign them to counsellors.",
        alt: "Lead capture and assignment",
      },
      {
        heading: "Track enrolment funnel",
        content:
          "See where prospects drop—from enquiry to counselling to payment—and optimise strategy.",
        alt: "Enrolment funnel tracking",
      },
      {
        heading: "Course-specific WhatsApp updates",
        content:
          "Send reminders and details using templates personalised by programme.",
        alt: "Personalised WhatsApp messaging",
      },
      {
        heading: "Counsellor performance insights",
        content:
          "Monitor how many leads reps handle, their conversions, and response time.",
        alt: "Counsellor productivity tracking",
      },
    ],
    image: realWorldImage6,
    alt: " Education and training institutes",
    subtitle:
      "Sales managers handle admissions, course enquiries, and counsellor output. Pepper Cloud provides the control they need.",
  },
];
const SalesMangers = () => {
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const classes = useStyles();
  const sectionRef = useRef(null);
  const [userSelected, setUserSelected] = useState(false);

  useEffect(() => {
    let interval;

    const startAutoplay = () => {
      clearInterval(interval);
      interval = setInterval(() => {
        setActiveAccordian((prev) => (prev + 1) % experienceList.length);
      }, AUTO_PLAY_INTERVAL);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          startAutoplay();
        } else {
          clearInterval(interval);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      clearInterval(interval);
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [experienceList.length]);

  // When user clicks on an accordion
  const handleAccordionClick = (index) => {
    setActiveAccordian(index);
    setUserSelected(true);

    // Restart autoplay so the full interval is shown after click
    // Without resetting to the next immediately
    clearInterval(intervalId);
    intervalId = setInterval(() => {
      setActiveAccordian((prev) => (prev + 1) % experienceList.length);
    }, AUTO_PLAY_INTERVAL);
  };

  useEffect(() => {
    // Select all cards that should have the effect
    const cardsToAnimate = [
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}:first-child`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.blueCard`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard`
      ),
    ];

    const setupCard = (card) => {
      if (!card) return;

      card.classList.add("glass-effect");

      const setInitialPosition = () => {
        const rect = card.getBoundingClientRect();
        const topRightX = rect.width - 150;
        const topRightY = 0;

        card.style.setProperty("--before-left", `${topRightX}px`);
        card.style.setProperty("--before-top", `${topRightY}px`);
        card.style.setProperty("--before-opacity", "0.8");
      };

      setInitialPosition();

      let lastX = null;
      let lastY = null;

      const handleMouseMove = (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        lastX = x;
        lastY = y;

        card.style.setProperty("--before-left", `${x - 75}px`);
        card.style.setProperty("--before-top", `${y - 75}px`);
      };

      const handleMouseEnter = () => {
        if (lastX !== null && lastY !== null) {
          card.style.setProperty("--before-left", `${lastX - 75}px`);
          card.style.setProperty("--before-top", `${lastY - 75}px`);
        }
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handleMouseLeave = () => {
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handlers = {
        mousemove: handleMouseMove,
        mouseenter: handleMouseEnter,
        mouseleave: handleMouseLeave,
        resize: setInitialPosition,
      };

      card.handlers = handlers;

      card.addEventListener("mousemove", handlers.mousemove);
      card.addEventListener("mouseenter", handlers.mouseenter);
      card.addEventListener("mouseleave", handlers.mouseleave);
      window.addEventListener("resize", handlers.resize);
    };

    cardsToAnimate.forEach(setupCard);

    return () => {
      cardsToAnimate.forEach((card) => {
        if (!card?.handlers) return;

        const { handlers } = card;
        card.removeEventListener("mousemove", handlers.mousemove);
        card.removeEventListener("mouseenter", handlers.mouseenter);
        card.removeEventListener("mouseleave", handlers.mouseleave);
        window.removeEventListener("resize", handlers.resize);
      });
    };
  }, [classes]);
  //card height
  useEffect(() => {
    const updateCardHeights = () => {
      const cards = document.querySelectorAll(".bannerCard");

      cards.forEach((card) => {
        if (window.innerWidth <= 1024) {
          card.style.height = "auto"; // let it size naturally
        } else {
          const originalHeight = card.offsetHeight;
          card.style.height = `${originalHeight}px`; // add 100px
        }
      });
    };

    // Run on mount
    updateCardHeights();

    // Run on resize
    window.addEventListener("resize", updateCardHeights);
    return () => window.removeEventListener("resize", updateCardHeights);
  }, []);

  const allIcons = [
    {
      img: leadCaptureIcon,
      title: "Auto lead capture",
    },
    {
      img: contactManagemntIcon,
      title: "Contact management",
    },
    {
      img: pipelineIcon,
      title: "Pipeline management",
    },
    {
      img: omniChannelIcon,
      title: "Omnichannel CRM",
    },
    {
      img: emailMarketingIcon,
      title: "Email marketing",
    },
    {
      img: quatationIcon,
      title: "Quotation generation",
    },
    {
      img: salesForecastIcon,
      title: "Sales forecasting",
    },
    {
      img: opportunityMangeIcon,
      title: "Opportunity management",
    },
    {
      img: aiChatbotIcon,
      title: "AI chatbot",
    },
    {
      img: whatsappCrmIcon,
      title: "WhatsApp CRM",
    },
    {
      img: mobileCrmIcon,
      title: "Mobile CRM",
    },
    {
      img: utmTrackingIcon,
      title: "UTM tracking",
    },
    {
      img: realTimeDashboardIcon,
      title: "Real-time dashboard",
    },
    {
      img: voipToolIcon,
      title: "VOIP tool integration",
    },
    {
      img: videoConferencingIcon,
      title: "Video conferencing",
    },
  ];

  // Function to distribute icons across three tracks
  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title)
    );

    const logotrack1 = [];
    const logotrack2 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 2) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
    };
  }

  // Get the distributed icons
  const { logotrack1, logotrack2 } = distributeIcons(allIcons);

  useEffect(() => {
    // Infinite scroll functionality

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Clone the track content
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        // Set row height
        this.row.style.height = logos[0].offsetHeight + 20 + "px";

        // Set initial position for right-to-left movement
        if (this.direction === "left") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetWidth / 3;
        }

        // Start animation
        this.animate();
      }

      animate() {
        const animate = () => {
          // Update position based on direction
          if (this.direction === "left") {
            this.position -= this.speed;
            // Reset position when one-third of content has scrolled
            const oneThirdWidth = -this.track.offsetWidth / 3;
            if (this.position <= oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            // Reset position when one-third of content has scrolled
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }
    }

    // Initialize all rows with different speeds and directions
    document.querySelectorAll(".logos-row").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  const [lastScrollY, setLastScrollY] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollPosition(currentScrollY);
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // setSubMenuOpen(false);
        // setIsVisible(false);
      } else {
        // setSubMenuOpen(false);
        // setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);
  const { ref, inView } = useInView({
    threshold: 0.5, // adjust as needed
    triggerOnce: false,
  });

  const benifitList = [
    {
      img: industryIntegration,
      title: "Why do sales managers need a CRM?",
      desc: "Sales managers deal with many sales representatives and monitor multiple deals and opportunities - often with limited visibility. Without the right CRM tool, staying in control becomes a challenge. Pepper Cloud sales CRM gives sales managers complete oversight with real-time data, automated workflows, and intuitive dashboards. The CRM empowers the teams with auto-lead assignment, easy pipeline management, sales forecasting and actionable AI insights.",
    },
  ];
  useEffect(() => {
    // Select all cards that should have the effect
    const cardsToAnimate = [
      document.querySelector(`.${classes.cardContainer}:first-child`),
      document.querySelector(`.${classes.cardContainer}.blueCard`),
      ...document.querySelectorAll(`.${classes.cardContainer}.regularCard`),
      ...document.querySelectorAll(`.${classes.cardContainer}.purpleCard`),
      ...document.querySelectorAll(`.${classes.cardContainer}.greenCard`), // Add regularCards
    ];

    cardsToAnimate.forEach((card) => {
      if (!card) return;

      card.classList.add("glass-effect");

      // Set initial top-right position for the glass effect
      const setInitialPosition = () => {
        const rect = card.getBoundingClientRect();
        const topRightX = rect.width - 150; // Adjust this value to position from right edge
        const topRightY = 0; // Top position

        card.style.setProperty("--before-left", `${topRightX}px`);
        card.style.setProperty("--before-top", `${topRightY}px`);
        card.style.setProperty("--before-opacity", "0.8");
      };

      // Call it initially
      setInitialPosition();

      let lastX = null;
      let lastY = null;

      const handleMouseMove = (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        lastX = x;
        lastY = y;

        card.style.setProperty("--before-left", `${x - 75}px`);
        card.style.setProperty("--before-top", `${y - 75}px`);
      };

      const handleMouseEnter = () => {
        if (lastX !== null && lastY !== null) {
          card.style.setProperty("--before-left", `${lastX - 75}px`);
          card.style.setProperty("--before-top", `${lastY - 75}px`);
        }
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handleMouseLeave = () => {
        card.style.setProperty("--before-opacity", "0.8");
      };

      // Store handlers on the card element for cleanup
      card.handlers = {
        mousemove: handleMouseMove,
        mouseenter: handleMouseEnter,
        mouseleave: handleMouseLeave,
        resize: setInitialPosition,
      };

      // Add event listeners
      card.addEventListener("mousemove", handleMouseMove);
      card.addEventListener("mouseenter", handleMouseEnter);
      card.addEventListener("mouseleave", handleMouseLeave);
      window.addEventListener("resize", setInitialPosition);
    });

    // Cleanup
    return () => {
      cardsToAnimate.forEach((card) => {
        if (!card) return;

        const handlers = card.handlers;
        if (handlers) {
          card.removeEventListener("mousemove", handlers.mousemove);
          card.removeEventListener("mouseenter", handlers.mouseenter);
          card.removeEventListener("mouseleave", handlers.mouseleave);
          window.removeEventListener("resize", handlers.resize);
        }
      });
    };
  }, [classes]);
  const faqs = [
    {
      question:
        "What makes Pepper Cloud the best CRM for salespeople and managers?",
      answer: (
        <>
          It combines <strong>pipeline visibility</strong>, smart automation,
          and insightful reporting—helping you coach your team, improve
          forecasting, and hit targets faster.
        </>
      ),
    },
    {
      question: "Is it suitable for multi-level sales teams?",
      answer: (
        <>
          Absolutely. Assign roles, set permissions, and create team-specific
          pipelines—all while keeping everything aligned and collaborative.
        </>
      ),
    },
    {
      question: "Which CRM is best for sales?",
      answer: (
        <>
          The best CRM for sales is one that helps you streamline the sales
          process, gain full visibility into your pipeline, and automate daily
          tasks. <strong>Pepper Cloud CRM</strong> is built for sales-driven
          teams—offering real-time analytics, smart automation, and mobile
          access to help sales managers lead smarter and close more deals,
          faster.
        </>
      ),
    },
    {
      question: "What are the top 3 CRM systems?",
      answer: (
        <>
          The top 3 CRM systems widely used by sales teams in 2025 are:
          <ul>
            <li>
              <strong>Pepper Cloud CRM</strong> – purpose-built for SMEs with
              AI-powered automation and multichannel integration
            </li>
            <li>
              <strong>Zoho CRM</strong> – a flexible system for sales and
              marketing alignment
            </li>
            <li>
              <strong>Pipedrive</strong> – a visual sales CRM designed for
              pipeline management
            </li>
          </ul>
          Each CRM has its strengths, but Pepper Cloud stands out for its
          simplicity, automation, and WhatsApp CRM features tailored to sales
          leaders.
        </>
      ),
    },
    {
      question: "What is CRM for sales management?",
      answer: (
        <>
          CRM for sales management refers to a system that helps sales leaders
          track team performance, monitor deal progress, and coach reps more
          effectively. It provides centralised data, real-time dashboards, and
          automation tools that simplify lead assignments, forecast accuracy,
          and team collaboration.
        </>
      ),
    },
    {
      question: "Who benefits from a CRM system?",
      answer: (
        <>
          Sales managers, sales reps, marketers, support teams, and business
          owners all benefit from a CRM system. It keeps everyone aligned,
          improves customer interactions, and ensures no opportunity is missed.
          For sales leaders, a CRM is essential for strategic decision-making
          and scaling revenue operations.
        </>
      ),
    },
    {
      question: "What are the advantages and disadvantages of CRM?",
      answer: (
        <>
          <strong>Advantages:</strong>
          <ul>
            <li>Better pipeline visibility</li>
            <li>Enhanced team collaboration</li>
            <li>Data-driven decision-making</li>
            <li>Automation of repetitive tasks</li>
            <li>Improved customer experience</li>
          </ul>
          <strong>Disadvantages (if not chosen wisely):</strong>
          <ul>
            <li>Complexity in large enterprise CRMs</li>
            <li>Poor adoption without proper training</li>
            <li>Costs may vary depending on features and users</li>
          </ul>
          Pepper Cloud solves these challenges by offering an easy-to-use,
          scalable CRM with expert onboarding and affordable pricing for growing
          businesses.
        </>
      ),
    },
  ];

  const adaptList = [
    {
      pointer: "Clear visibility into the sales pipeline",
      desc: "Monitor lead sources, stages, and team activities in real time using customisable pipelines and visual dashboards.",
      img: salesImg1,
      alt: "Clear visibility into the sales pipeline",
    },
    {
      pointer: "Centralised team communication",
      desc: "Manage all WhatsApp chats in a shared inbox, send broadcasts, and respond faster using templates and product catalogues.",
      img: salesImg2,
      alt: "Centralised team communication",
    },
    {
      pointer: "Smart task and activity management",
      desc: "Assign tasks, set reminders, and automate daily follow-ups so your team stays focused and nothing gets missed.",
      img: salesImg3,
      alt: "Smart task and activity management",
    },
    {
      pointer: "Mobile access for on-the-go leadership",
      desc: "Use mobile CRM to track pipelines, review reports, and stay in control—anytime, anywhere.",
      img: salesImg4,
      alt: "Mobile access for on-the-go leadership",
    },
    {
      pointer: "AI-powered features",
      desc: "In-built AI offers quick replies, task management, etc. to communicate faster and smarter.",
      img: salesImg5,
      alt: "AI-powered features",
    },
    {
      pointer: "Performance insights and reports",
      desc: "Get real-time dashboards to evaluate sales team performance and coach them with data-backed insights.",
      img: salesImg6,
      alt: "Performance insights and reports",
    },
  ];
  const clientList = [
    {
      img: adaptImg1,
    },
    {
      img: adaptImg2,
    },
    {
      img: adaptImg3,
    },
    {
      img: adaptImg4,
    },
    {
      img: adaptImg5,
    },
    {
      img: adaptImg6,
    },
    {
      img: adaptImg7,
    },
  ];

  // sales rep contents
  const bannerPoints = [
    "AI-powered sales insights",
    "WhatsApp CRM for real-time communication",
    "Smart sales automation and reminders",
    "Customisable sales pipelines and activity tracking",
  ];
  const compareItems = [
    "Pepper Cloud CRM",
    "Zoho CRM",
    "Pipedrive",
    "Freshsales CRM ",
    "Monday CRM",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "The best CRM for sales managers in SMEs—Pepper Cloud offers real-time insights, performance coaching tools, and automation, all in a user-friendly interface.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "Custom reporting",
          desc: "Create and share dashboards that align with team goals and sales KPIs.",
        },
        {
          title: "Track and manage sales activities",
          desc: "Schedule events, assign tasks, and monitor follow-ups to keep your sales agents aligned and proactive.",
        },
        {
          title: "Workflow automation",
          desc: "Set automated rules for follow-ups, stage changes, and team notifications.",
        },
        {
          title: "Multichannel communication",
          desc: "Oversee conversations across WhatsApp, email, and social channels.",
        },
        {
          title: "Mobile CRM",
          desc: "Access performance data and manage your team anytime, anywhere.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM provides customisable tools to help managers oversee pipelines, automate tasks, and improve sales efficiency.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "Advanced analytics",
          desc: "Track KPIs and performance across all channels.",
        },
        {
          title: "Team collaboration",
          desc: "Assign leads, manage workflows, and share progress in real time.",
        },
        {
          title: "Email automation",
          desc: "Set automated cadences for timely communication.",
        },
      ],
    },
    {
      title: "Pipedrive",
      desc: "Pipedrive helps sales leaders visualise the pipeline and manage activities to improve conversion.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "Customisable pipeline",
          desc: "Get a clear view of deals and sales stages.",
        },
        {
          title: "Deal insights",
          desc: "Know which reps are winning and why.",
        },
        {
          title: "Goal tracking",
          desc: "Set and monitor targets across teams.",
        },
      ],
    },
    {
      title: "Freshsales CRM",
      desc: "Built for managers who want to accelerate team performance with automation and AI.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Activity tracking",
          desc: "Get insights into rep activity and deal health.",
        },
        {
          title: "AI recommendations",
          desc: "Identify hot leads and next steps automatically.",
        },
        {
          title: "Mobile support",
          desc: "Manage your team and deals on the go.",
        },
      ],
    },
    {
      title: "Monday CRM",
      desc: "An intuitive CRM for growing teams needing flexible reporting and team management.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "Visual dashboards",
          desc: "Monitor pipelines and metrics in one view.",
        },
        {
          title: "Custom workflows",
          desc: "Build processes tailored to your sales cycle.",
        },
        {
          title: "Team tasking",
          desc: "Assign and track responsibilities easily.",
        },
      ],
    },
  ];
  const broadcastList = [
    {
      pointer: "CRM for sales development reps",
      link: "/teams/best-crm-for-sales-reps/",
      card: {
        pointer: [
          "Qualify leads, automate outreach, and book meetings faster with integrated calling and task tools.",
        ],
        img: broadcastImg2,
        alt: "Create whatsapp broadcast message​",
        backgroundColor: "#014957",
        backgroundImage: "linear-gradient(to bottom, #014957, #028ba6)",
      },
    },
    {
      pointer: "CRM for marketing teams",
      card: {
        pointer: [
          "Launch campaigns and capture more leads with ease while tracking performance in real-time and managing all campaign activities.",
        ],
        img: broadcastImg3,
        alt: "Create whatsapp broadcast message​",
        backgroundColor: " #31114b",
        backgroundImage: "linear-gradient(to bottom, #31114b, #783ca8);",
      },
    },
    {
      pointer: "CRM for customer support teams",
      card: {
        pointer: [
          "Respond faster, manage tickets efficiently, and improve satisfaction with smart support workflows.",
        ],
        img: broadcastImg4,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: "#2788e7",
        backgroundImage: "linear-gradient(to bottom, #2788e7, #783ca8)",
      },
    },
    {
      pointer: "CRM for business owners",
      card: {
        pointer: [
          "Gain full visibility and control from one platform with real-time insights, revenue trends, and business growth metrics.",
        ],
        img: broadcastImg5,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: "#09939a",
        backgroundImage: " linear-gradient(to bottom, #09939a, #783ca8)",
      },
    },
    {
      pointer: "CRM for IT and tech teams",
      card: {
        pointer: [
          "Streamline service delivery, automate workflows, and manage client support with ease.",
        ],
        img: broadcastImg1,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: " #0A2F4F",
        backgroundImage: " linear-gradient(180deg, #0A2F4F 0%, #2576BB 100%)",
      },
    },
  ];

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  return (
    <main>
      <SEO
        description={
          "Discover the best CRM for sales managers to track performance, automate tasks, and scale sales. Empower your team with Pepper Cloud AI-powered CRM."
        }
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is the role of CRM in retail?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Retail CRM plays a crucial role in managing customer interactions, tracking sales, and enhancing service across both online and offline channels.",
                },
              },
              {
                "@type": "Question",
                name: "Why is a specialized CRM necessary for e-commerce?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A specialized e-commerce CRM addresses challenges such as cart abandonment, personalized recommendations, and multichannel support, ultimately enhancing customer experience and driving sales.",
                },
              },
              {
                "@type": "Question",
                name: "Is investing in a CRM worthwhile for small businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is beneficial for small e-commerce businesses as it improves customer service, streamlines operations, and enables data-driven decision-making, leading to growth and increased profitability.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud assist with cart abandonment?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM automates cart abandonment recovery through targeted reminders and incentives, resulting in increased conversions.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud facilitate multichannel sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM offers omnichannel capabilities, managing sales and customer interactions across websites, marketplaces, and social media platforms for a unified customer view.",
                },
              },
            ],
          },
        ]}
        keywords="Best crm for sales reps,Sales agents,Best crm for sales teams,best crm software,Crm software for sales and marketing,best sales crm,CRM software for small businesses"
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        pathname={"https://peppercloud.com/teams/best-crm-for-sales-reps/"}
        title={
          "Best CRM for sales managers | Drive sales growth with Pepper Cloud"
        }
      />

      <div className={clsx(classes.SalesMangerSection, "sales-hero-section")}>
        <div className="container">
          <div className={classes.SalesMangerContainer}>
            <motion.div
              className={classes.heroContent}
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              <h1 className="font-wix-semibold font-64 ">
                Best CRM for Sales Managers to <br /> drive performance
              </h1>
              <p className="font-wix-regular font-18">
                Empower your sales managers with full pipeline visibility,
                real-time team tracking, and AI-powered insights. Pepper Cloud
                CRM helps streamline collaboration, boost accountability, and
                improve sales outcomes—without messy spreadsheets.
              </p>
              <div className="buttonContainer">
                <Link
                  className=" primaryButton font-inter-medium font-18 font-white"
                  initial={{ opacity: 1, y: 20 }}
                  to={"/contact/"}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Book a free demo
                </Link>
              </div>
            </motion.div>
            <motion.div
              className={classes.bannerCards}
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              <div
                className={clsx(
                  classes.cardContainer,
                  "bannerCard",
                  "blueCard"
                )}
                // onMouseEnter={() => !isMobile && setIsHovering3(true)}
                // onMouseLeave={() => !isMobile && setIsHovering3(false)}
              >
                <img src={bannerIcon1} />
                <h3 className="font-wix-semibold font-20 font-white">
                  Mobile CRM
                </h3>
                <p className="font-wix-regular font-18 color-black7">
                  Follow up on sales team activities anywhere, anytime with
                  mobile CRM. Track and monitor performance in real time.
                </p>
              </div>
              <div
                className={clsx(
                  classes.cardContainer,
                  "bannerCard",
                  "greenCard"
                )}
                // onMouseEnter={() => !isMobile && setIsHovering4(true)}
                // onMouseLeave={() => !isMobile && setIsHovering4(false)}
              >
                <img src={bannerIcon2} />
                <h3 className="font-wix-semibold font-20 font-white">
                  WhatsApp CRM
                </h3>
                <p className="font-wix-regular font-18 color-black7">
                  Enable faster and more personalised communication with team
                  members and clients directly through WhatsApp.
                </p>
              </div>
              <div
                className={clsx(
                  classes.cardContainer,
                  "bannerCard",
                  "regularCard"
                )}
                // onMouseEnter={() => !isMobile && setIsHovering5(true)}
                // onMouseLeave={() => !isMobile && setIsHovering5(false)}
              >
                <img src={bannerIcon3} />
                <h3 className="font-wix-semibold font-20 font-white">
                  AI-powered
                </h3>
                <p className="font-wix-regular font-18 color-black7">
                  Auto-respond to customer queries, FAQs, etc. with AI chatbot.
                  Access information and insight instantly.
                </p>
              </div>
              <div
                className={clsx(
                  classes.cardContainer,
                  "bannerCard",
                  "purpleCard"
                )}
                // onMouseEnter={() => !isMobile && setIsHovering5(true)}
                // onMouseLeave={() => !isMobile && setIsHovering5(false)}
              >
                <img src={bannerIcon4} />
                <h3 className="font-wix-semibold font-20 font-white">
                  Performance dashboards
                </h3>
                <p className="font-wix-regular font-18 color-black7">
                  Monitor sales pipelines, team activities, and KPIs from a
                  single, easy-to-use dashboard.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
      <section className={classes.Client}>
        <div className="container">
          <p className="font-24 font-wix-semibold">
            Trusted by sales team managers across industries
          </p>
          <Swiper
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
            }}
            breakpoints={{
              // For smaller screens (mobile)
              0: {
                slidesPerView: 2,
                freeMode: true,
                // grabCursor: false,
                spaceBetween: 40,
                slidesPerGroup: 1,
                // autoplay: false,
                // modules: [],
              },
              // For larger screens (desktop)
              768: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 4,
                slidesPerGroup: 1,
                spaceBetween: 40,
              },
              1200: {
                slidesPerView: 4,
                slidesPerGroup: 1,
                spaceBetween: 40,
              },
            }}
            className={classes.adaptSlider}
            grabCursor={true}
            loop={true}
            modules={[Autoplay]}
            speed={2500}
            slidesPerView={"auto"}
            // centeredSlides={true}
            spaceBetween={30}
          >
            {clientList.map((point) => (
              <SwiperSlide className="client-logo">
                <div>
                  <img
                    // alt={point.card.alt}
                    src={point.img}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
      {benifitList.map((benifit) => (
        <section className={classes.integrationSection}>
          <div className="container">
            <div className={classes.integrationHeader}>
              <div className={classes.integrationLeft}>
                <motion.h2
                  className="font-wix-semibold font-56 color-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {benifit.title}
                </motion.h2>
                <motion.p
                  className="font-wix-regular font-18 color-black1 mt20"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {benifit.desc}
                </motion.p>
              </div>
              <div className={classes.integrationRight}>
                <img
                  alt="Best CRM for sales managers"
                  className={classes.integrationRightImage}
                  src={benifit.img}
                />
              </div>
            </div>
          </div>
        </section>
      ))}

      <section className={classes.salesCrmCarousel}>
        <div className="container">
          <div className="header-section">
            <motion.h2
              className="font-wix-semibold font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Key sales CRM features sales managers need
            </motion.h2>
            <motion.p
              className="font-wix-regular font-18 color-black2"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Sales managers need more than lead tracking—they need clarity,
              control, and coaching tools. Pepper Cloud CRM empowers leaders to
              drive performance, automate oversight, and scale success. Here's
              how it delivers:
            </motion.p>
          </div>
        </div>
        <Swiper
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: 1,
              freeMode: true,
              // grabCursor: false,
              spaceBetween: 15,
              slidesPerGroup: 1,
              // autoplay: false,
              // modules: [],
            },
            // For larger screens (desktop)
            768: {
              slidesPerView: 2,
              slidesPerGroup: 1,
              spaceBetween: 15,
            },
            1024: {
              slidesPerView: 4,
              slidesPerGroup: 1,
              spaceBetween: 15,
            },
          }}
          className={classes.adaptSlider}
          grabCursor={true}
          loop={true}
          modules={[Autoplay]}
          speed={5000}
          slidesPerView={"auto"}
          // centeredSlides={true}
          spaceBetween={30}
        >
          {adaptList.map((point, index) => (
            <SwiperSlide className={classes.adaptsBox}>
              <div className={classes.adaptBoxHeader}>
                <img
                  // alt={point.card.alt}
                  className={classes.adaptBoxImg}
                  src={point.img}
                />
                <p className="font-24 font-wix-semibold lineHeight-1">
                  {point.pointer}
                </p>
              </div>
              <div className={classes.adaptDescription}>
                <p className="font-wix-regular font-18  ">{point.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      <section className={classes.experienceContainer} ref={ref}>
        <section className={classes.accordianTabs}>
          <div className="container">
            <div className="headercenterContainer">
              <motion.h2
                className="font-wix-semibold font-56 text-black1"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Why Pepper Cloud is the best CRM software
              </motion.h2>
              <p className="font-18 font-wix-regular text-black2">
                Pepper Cloud CRM helps sales managers lead with clarity,
                automate team operations, and make informed decisions. With
                centralised pipelines, real-time reporting, and AI support,
                managers can coach smarter and close faster—no matter the team
                size.
              </p>
            </div>
            <div className={classes.experienceInnerContainer}>
              <div className={classes.experienceContainerRight}>
                {experienceList.map(
                  (experience, index) =>
                    index === activeAccordian && (
                      <motion.img
                        alt={experience.alt}
                        initial={{ opacity: 1, y: 20 }}
                        src={experience.img}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      />
                    )
                )}
              </div>
              <div className={classes.experienceContainerLeft} ref={sectionRef}>
                {experienceList.map((faq, index) => (
                  <motion.div
                    className={clsx(
                      classes.faqBoxAccordian,
                      index === activeAccordian && "active",
                      "text-color2"
                    )}
                    key={`faq-${index}-${activeAccordian === index}`}
                    onClick={() => setActiveAccordian(index)}
                    transition={{ duration: 1, delay: index * 0.01 }}
                    whileInView={{ opacity: [0, 1], y: [50, 0] }}
                  >
                    <div className={classes.experienceHeader}>
                      <h3 className="font-20 font-wix-semibold">{faq.title}</h3>
                    </div>
                    <Collapse
                      className={classes.collapseBody}
                      in={activeAccordian === index}
                    >
                      <p className="font-18 font-wix-regular color-black2 exp-desc">
                        {faq.desc}
                      </p>
                      <a
                        className="font-18 color-black1 font-wix-regular view-more-link"
                        href={faq.linkUrl}
                      >
                        {faq.lintText}{" "}
                        <img alt="Arrow Right" src={arrowRight} />{" "}
                      </a>
                      <motion.img
                        alt={faq.alt}
                        initial={{ opacity: 1, y: 20 }}
                        src={faq.img}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      />
                    </Collapse>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
          <div className={classes.absoulteCard}>
            <TruestedSection background={true} />
          </div>
        </section>

        <section className={classes.realWorldTabs}>
          <div className="container">
            <div className="centerContainer">
              <motion.h2
                className="font-wix-semibold font-56 color-black1"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Application and use cases of best CRM for sales team managers
              </motion.h2>
              <div className={classes.tabsContainer}>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-18",
                    activeRealWorld === 0 && "active"
                  )}
                  onClick={() => setActiveRealWorld(0)}
                >
                  SaaS and IT services
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-18",
                    activeRealWorld === 1 && "active"
                  )}
                  onClick={() => setActiveRealWorld(1)}
                >
                  Manufacturing
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-18",
                    activeRealWorld === 2 && "active"
                  )}
                  onClick={() => setActiveRealWorld(2)}
                >
                  Interior design firms
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-18",
                    activeRealWorld === 3 && "active"
                  )}
                  onClick={() => setActiveRealWorld(3)}
                >
                  Financial services
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-18",
                    activeRealWorld === 4 && "active"
                  )}
                  onClick={() => setActiveRealWorld(4)}
                >
                  Education
                </div>
              </div>
            </div>

            <div className={classes.tabCard}>
              <div className={classes.tabCardLeftContainer}>
                {tabContentData.map(
                  (listItem, index) =>
                    index === activeRealWorld && (
                      <div>
                        <motion.p
                          className="font-wix-regular font-18 color-black2"
                          initial={{ opacity: 0, y: 20 }}
                          transition={{ duration: 0.3 }}
                          whileInView={{ opacity: 1, y: 0 }}
                        >
                          {listItem.subtitle}
                        </motion.p>
                        <div className={classes.benfitListContainer}>
                          {listItem.tabContent.map((item) => (
                            <motion.div
                              className={classes.benfitListItem}
                              initial={{ opacity: 0, y: 20 }}
                              transition={{ duration: 0.3 }}
                              whileInView={{ opacity: 1, y: 0 }}
                            >
                              <LazyImage
                                alt={item.alt}
                                className={classes.benfitIcon}
                                source={bannerTick}
                              />
                              <div className={classes.benfitListItemContent}>
                                <p className="font-wix-semibold font-20 color-black1">
                                  {item.heading}
                                </p>
                                <p className="font-wix-regular font-18 color-black2">
                                  {item.content}
                                </p>
                              </div>
                            </motion.div>
                          ))}
                        </div>
                      </div>
                    )
                )}
              </div>
              <div className={classes.tabCardRightContainer}>
                {tabContentData.map(
                  (listItem, index) =>
                    index === activeRealWorld && (
                      <motion.div
                        initial={{ opacity: 1, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        // className={classes.aiSectionRight}
                      >
                        <LazyImage
                          alt={listItem.alt}
                          source={listItem.image}
                          width={"100%"}
                        />
                      </motion.div>
                    )
                )}
              </div>
            </div>
          </div>
        </section>
      </section>

      <section className={classes.combineSection}>
        <div className={classes.bussinessSuccesSection}>
          <div className={classes.bussinessSuccessContainer}>
            <div className={classes.integrationHeaderItem}>
              <div className={classes.integrationContent}>
                <motion.p
                  className="font-wix-semibold font-20 color-blue-primary"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Features
                </motion.p>
                <motion.h2
                  className="font-wix-semibold font-56 color-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Tailored for business success
                </motion.h2>
                <motion.p
                  className="font-wix-regular font-18 color-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  The best CRM for sales managers and sales representatives to
                  accelerate sales process, stay organised, and win more deals.
                </motion.p>
              </div>
            </div>

            <section className="sales-manager-logo-carousel">
              <div className="logos-container">
                <div className="scroll-container">
                  <div
                    className="logos-row"
                    data-direction="left"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {logotrack1.map((logo) => (
                        <div
                          className="logo font-18 font-wix-medium"
                          key={logo.title}
                        >
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div
                    className="logos-row"
                    data-direction="right"
                    data-speed="0.4"
                  >
                    <div className="logos-track">
                      {logotrack2.map((logo) => (
                        <div className="logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
      <div className="container">
        <div className="header">
          <motion.h2
            className="font-wix-semibold font-56 font-black1"
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Top 5 best CRM software for sales managers in 2025
          </motion.h2>
        </div>
        <div className={classes.compareSectionContainer}>
          <div className={classes.compareSectionContainerLeftSection}>
            {compareItems.map((item, index) => (
              <div
                className={clsx(
                  classes.compareSectionLeftItem,
                  activeCompare === `#section${index}` && "active"
                )}
                onClick={() => {
                  scrollToSection(`#section${index}`);
                  setActiveCompare(`#section${index}`);
                }}
              >
                <a
                  className={clsx(
                    "font-22 font-wix-medium font-black1",
                    activeCompare === `#section${index}` && "font-wix-semibold"
                  )}
                  href={`#section${index}`}
                >
                  {item}
                </a>
              </div>
            ))}
          </div>
          <div className={classes.compareSectionContainerRightSection}>
            {compareData.map((data, outerIndex) => (
              <div
                className={classes.compareItemContainer}
                id={`#section${outerIndex}`}
              >
                <h3
                  className="font-40 font-wix-semibold font-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {data.title}
                </h3>
                <p
                  className="font-wix-regular font-18 font-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {data.desc}
                </p>
                <img alt={data.alt} className="productImage" src={data.img} />
                <div className={classes.faqsContainer}>
                  {data.features.map((faq, innerIndex) => (
                    <motion.div
                      className={classes.faqBox}
                      onClick={() =>
                        setActiveAccordian(
                          `${outerIndex}-${innerIndex}` === activeAccordian
                            ? -1
                            : `${outerIndex}-${innerIndex}`
                        )
                      }
                      transition={{ duration: 1, delay: innerIndex * 0.01 }}
                      whileInView={{ opacity: [0, 1], y: [50, 0] }}
                    >
                      <div className={classes.topFiveHeader}>
                        <h3 className="font-20 font-wix-semibold">
                          {faq.title}
                        </h3>
                        <img
                          alt="Arrow"
                          className={clsx(
                            classes.downArrow,
                            `${outerIndex}-${innerIndex}` === activeAccordian &&
                              "active"
                          )}
                          src={downArrow}
                        />
                      </div>
                      <Collapse
                        className={classes.body}
                        in={activeAccordian === `${outerIndex}-${innerIndex}`}
                      >
                        <p className="font-18 font-wix-regular color-black2">
                          {faq.desc}
                        </p>
                      </Collapse>
                    </motion.div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={classes.testimonials}>
        <TestimonialSlider
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
          heading={"Real stories. Real results."}
          noButton={true}
        />
      </div>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFFFFF"}
          faqs={faqs}
          heading={
            "Frequently asked questions - Best CRM system for sales managers "
          }
        />
      </div>
      <DesignCrmCarousel backgroundImage={""} bgColor={"#e9f4fd"} />
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Try our best CRM for sales and marketing.
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default SalesMangers;
